<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
    <a-modal :title="state.modalTitle" width="1200px" :open="open" :confirmLoading="state.loading" :maskClosable="false"
        :footer="null" :body-style="{ padding: 0 }" centered wrap-class-name="kezhang-modal-wrap"
        @cancel="() => emit('cancel')">
        <div class="kezhang-shell">
            <!-- ==================== 顶部：步骤条（可点击切换） ==================== -->
            <div class="shell-header">
                <a-steps :current="state.currentStep" size="small" class="shell-steps clickable-steps">
                    <a-step class="clickable-step" @click="handleStepClick(0)">
                        <template #title>上传资料</template>
                        <template #description>公章 / 财务章 / 姓名章</template>
                    </a-step>
                    <a-step class="clickable-step" @click="handleStepClick(1)">
                        <template #title>取章方式</template>
                        <template #description>快递 / 自取 / 跑腿</template>
                    </a-step>
                    <a-step class="clickable-step" @click="handleStepClick(2)">
                        <template #title>确认订单</template>
                        <template #description>核对金额并提交</template>
                    </a-step>
                </a-steps>
            </div>
            <!-- ==================== 主体 ==================== -->
            <div class="shell-body">
                <a-spin :spinning="state.loading" class="shell-spin">
                    <a-form ref="ruleForm" scrollToFirstError :model="formState" v-bind="formLayout" :rules="rules">
                        <!-- ============ 左侧：步骤导航 ============ -->
                        <aside class="shell-aside">
                            <div class="nav-item" :class="{ active: state.currentStep === 0 }"
                                @click="state.currentStep = 0">
                                <div class="nav-index">1</div>
                                <div class="nav-text">
                                    <div class="nav-title">上传资料</div>
                                    <div class="nav-desc">公章 / 财务章 / 法人章</div>
                                </div>
                            </div>
                            <div class="nav-item" :class="{ active: state.currentStep === 1 }"
                                @click="state.currentStep = 1">
                                <div class="nav-index">2</div>
                                <div class="nav-text">
                                    <div class="nav-title">取章方式</div>
                                    <div class="nav-desc">收货方式和地址</div>
                                </div>
                            </div>
                            <div class="nav-item" :class="{ active: state.currentStep === 2 }"
                                @click="state.currentStep = 2">
                                <div class="nav-index">3</div>
                                <div class="nav-text">
                                    <div class="nav-title">确认订单</div>
                                    <div class="nav-desc">核对金额后提交</div>
                                </div>
                            </div>
                        </aside>

                        <!-- ============ 右侧：内容区 ============ -->
                        <main class="shell-main">
                            <!-- ===== Step 1：上传资料 ===== -->
                            <div v-show="state.currentStep === 0" class="step-panel">
                                <!-- 刻章类型 + 印章状态 -->
                                <div class="panel-card">
                                    <a-form-item label="选择印章" name="beian_zhang" required :label-col="{ span: 4 }"
                                        :wrapper-col="{ span: 20 }">
                                        <a-checkbox-group v-model:value="formState.beian_zhang"
                                            @change="changeBeianZhang" class="seal-group">
                                            <a-row v-if="formState.pay_status != 1 || props.tableColumnsData?.isCopy"
                                                :gutter="[24, 8]">
                                                <a-col :span="8"><a-checkbox value="11"
                                                        class="seal-checkbox">备案公章</a-checkbox></a-col>
                                                <a-col :span="8"><a-checkbox value="12"
                                                        class="seal-checkbox">备案财务章</a-checkbox></a-col>
                                                <a-col :span="8"><a-checkbox value="13"
                                                        class="seal-checkbox">备案法人代表章</a-checkbox></a-col>
                                                <a-col :span="8"><a-checkbox value="14"
                                                        class="seal-checkbox">备案合同专用章</a-checkbox></a-col>
                                                <a-col :span="8"><a-checkbox value="15"
                                                        class="seal-checkbox">备案发票专用章</a-checkbox></a-col>
                                                <a-col :span="8"><a-checkbox value="16"
                                                        class="seal-checkbox">备案其他类型章</a-checkbox></a-col>
                                            </a-row>
                                            <div v-else class="seal-tags">
                                                <a-tag v-if="formState.beian_zhang.includes('11')"
                                                    color="blue">备案公章</a-tag>
                                                <a-tag v-if="formState.beian_zhang.includes('12')"
                                                    color="blue">备案财务章</a-tag>
                                                <a-tag v-if="formState.beian_zhang.includes('13')"
                                                    color="blue">备案法人代表章</a-tag>
                                                <a-tag v-if="formState.beian_zhang.includes('14')"
                                                    color="blue">备案合同专用章</a-tag>
                                                <a-tag v-if="formState.beian_zhang.includes('15')"
                                                    color="blue">备案发票专用章</a-tag>
                                                <a-tag v-if="formState.beian_zhang.includes('16')"
                                                    color="blue">备案其他类型章</a-tag>
                                            </div>
                                        </a-checkbox-group>
                                    </a-form-item>

                                    <a-form-item label="印章状态" required :label-col="{ span: 4 }"
                                        :wrapper-col="{ span: 20 }" style="margin-bottom: 0">
                                        <a-radio-group name="is_sunhuai" v-model:value="formState.is_sunhuai"
                                            button-style="solid"
                                            v-if="formState.status == 1 || formState.status == 3 || formState.status == null">
                                            <a-radio-button :value="2">新刻制</a-radio-button>
                                            <a-radio-button :value="1">变更刻制（损坏/遗失/主体变更）</a-radio-button>
                                        </a-radio-group>
                                        <div v-else>{{ formState.is_sunhuai == 1 ? '损坏/遗失/主体变更' : '正常' }}</div>
                                        <div v-if="formState.is_sunhuai == 1" class="inline-tip">
                                            印章损坏下载【附件二】签字盖章拍照上传；印章遗失需登报上传完整报纸或联系工作人员
                                        </div>
                                    </a-form-item>
                                </div>

                                <!-- 主体信息 -->
                                <div class="panel-card">
                                    <a-form-item label="营业执照" name="licence_url" required :label-col="{ span: 4 }"
                                        :wrapper-col="{ span: 20 }">
                                        <div class="licence-row">
                                            <div v-if="formState.status == 1 || formState.status == 3 || formState.status == null || state.user_permission == 'admin'"
                                                class="licence-upload-wrap">
                                                <a-spin :spinning="state.identifyItLoading">
                                                    <a-form-item-rest>
                                                        <a-upload list-type="picture-card" accept=".jpeg,.png,.jpg"
                                                            class="licence-uploader" :show-upload-list="false"
                                                            :before-upload="beforeUpload"
                                                            @change="(info) => handleLicenceCropper(info, 'licence_url')">
                                                            <img v-if="formState.licence_url"
                                                                :src="$store.state.user.image_domain + formState.licence_url"
                                                                class="licence-img" />
                                                            <div v-else class="licence-placeholder">
                                                                <PlusOutlined />
                                                                <div>上传营业执照</div>
                                                            </div>
                                                        </a-upload>
                                                    </a-form-item-rest>
                                                </a-spin>
                                            </div>
                                            <div v-else class="licence-viewer">
                                                <a-image :width="160"
                                                    :src="$store.state.user.image_domain + formState.licence_url" />
                                            </div>

                                            <div class="licence-fields">
                                                <a-form-item label="主体名称" name="full_name" required
                                                    :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"
                                                    :validate-status="checkdatastate.full_name" has-feedback
                                                    @change="() => (checkdatastate.full_name = formState.full_name ? 'success' : 'error')">
                                                    <a-input placeholder="请输入主体名称" v-model:value="formState.full_name"
                                                        @change="fullnameChange()"
                                                        :disabled="!(formState.status == 1 || formState.status == 3 || formState.status == null || state.user_permission == 'admin')" />
                                                </a-form-item>
                                                <a-form-item label="信用代码" name="social_credit_code" required
                                                    :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                                                    <a-input placeholder="请输入统一社会信用代码"
                                                        v-model:value="formState.social_credit_code"
                                                        :disabled="!(formState.status == 1 || formState.status == 3 || formState.status == null || state.user_permission == 'admin')" />
                                                </a-form-item>
                                                <a-form-item label="单位类型" required :label-col="{ span: 6 }"
                                                    :wrapper-col="{ span: 18 }" style="margin-bottom: 0">
                                                    <a-select allow-clear v-model:value="formState.unit_type"
                                                        placeholder="请选择单位类型">
                                                        <a-select-option :value="1">企业单位</a-select-option>
                                                        <a-select-option :value="2">个体工商户</a-select-option>
                                                        <a-select-option :value="3">农民专业合作社</a-select-option>
                                                        <a-select-option :value="4">事业单位</a-select-option>
                                                        <a-select-option :value="5">社会团体</a-select-option>
                                                        <a-select-option :value="6">民营/民办非企业单位</a-select-option>
                                                        <a-select-option :value="7">党政机关/国家机关</a-select-option>
                                                        <a-select-option :value="8">其他</a-select-option>
                                                    </a-select>
                                                </a-form-item>
                                            </div>
                                        </div>
                                    </a-form-item>

                                    <a-form-item label="委托书/报纸" v-if="state.showAttach || formState.is_sunhuai == 1"
                                        :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" style="margin-bottom: 0">
                                        <Upload
                                            :upload_path="`public/uploads/kezhang_fileupload_tmp/${dayjs().format('YYYYMM')}/`"
                                            :accept="['png', 'jpg', 'jpeg']" uploadType="picture-card" :limitation="99"
                                            v-model:value="formState.attach_url" uploadText="上传附件" />
                                        <div class="inline-tip">
                                            分公司需上传总公司盖章、分公司负责人签字的授权委托书。
                                            <a @click="getFileDownLoad('分公司刻章，总公司授权书2026.docx')">
                                                <VerticalAlignBottomOutlined /> 模板下载
                                            </a>
                                        </div>
                                    </a-form-item>
                                </div>

                                <!-- 法人代表信息 + 照片 -->
                                <div class="panel-card">
                                    <a-form-item label="（法人代表/负责人）照片" required :label-col="{ span: 5 }"
                                        :wrapper-col="{ span: 19 }">
                                        <div class="photo-row">
                                            <div class="photo-item">
                                                <a-spin :spinning="state.loading_front"
                                                    v-if="formState.status == 1 || formState.status == 3 || formState.status == null || state.user_permission == 'admin'">
                                                    <a-form-item-rest>
                                                        <a-upload list-type="picture-card" accept=".jpeg,.png,.jpg"
                                                            class="photo-uploader" :show-upload-list="false"
                                                            :before-upload="beforeUpload"
                                                            @change="(info) => handleChange(info, 'id_card_front')">
                                                            <img v-if="formState.id_card_front"
                                                                :src="$store.state.user.image_domain + formState.id_card_front"
                                                                class="photo-img" />
                                                            <div v-else class="photo-placeholder">
                                                                <PlusOutlined />
                                                                <div>身份证人像面</div>
                                                            </div>
                                                        </a-upload>
                                                    </a-form-item-rest>
                                                </a-spin>
                                                <a-image v-else :width="130" :height="85"
                                                    :src="$store.state.user.image_domain + formState.id_card_front" />
                                            </div>

                                            <div class="photo-item">
                                                <a-spin :spinning="state.loading_back"
                                                    v-if="formState.status == 1 || formState.status == 3 || formState.status == null || state.user_permission == 'admin'">
                                                    <a-form-item-rest>
                                                        <a-upload list-type="picture-card" accept=".jpeg,.png,.jpg"
                                                            class="photo-uploader" :show-upload-list="false"
                                                            :before-upload="beforeUpload"
                                                            @change="(info) => handleChange(info, 'id_card_back')">
                                                            <img v-if="formState.id_card_back"
                                                                :src="$store.state.user.image_domain + formState.id_card_back"
                                                                class="photo-img" />
                                                            <div v-else class="photo-placeholder">
                                                                <PlusOutlined />
                                                                <div>身份证国徽面</div>
                                                            </div>
                                                        </a-upload>
                                                    </a-form-item-rest>
                                                </a-spin>
                                                <a-image v-else :width="130" :height="85"
                                                    :src="$store.state.user.image_domain + formState.id_card_back" />
                                            </div>

                                            <div class="photo-item">
                                                <a-form-item-rest
                                                    v-if="formState.status == 1 || formState.status == 3 || formState.status == null || state.user_permission == 'admin'">
                                                    <a-upload list-type="picture-card" accept=".jpeg,.png,.jpg"
                                                        class="photo-uploader" :show-upload-list="false"
                                                        :before-upload="beforeUpload"
                                                        @change="(info) => handleImageChange(info, 'one_inch_picture')">
                                                        <img v-if="formState.one_inch_picture"
                                                            :src="$store.state.user.image_domain + formState.one_inch_picture"
                                                            class="photo-img" />
                                                        <div v-else class="photo-placeholder">
                                                            <PlusOutlined />
                                                            <div>用户自拍照</div>
                                                        </div>
                                                    </a-upload>
                                                </a-form-item-rest>
                                                <a-image v-else :width="130" :height="85"
                                                    :src="$store.state.user.image_domain + formState.one_inch_picture" />
                                            </div>
                                        </div>
                                        <div class="inline-tip">
                                            身份证不能带水印、自拍照不能用身份证截图，否则公安局备案通不过
                                        </div>
                                    </a-form-item>

                                    <a-row :gutter="24">
                                        <a-col :span="12">
                                            <a-form-item label="（法人代表/负责人）姓名" name="fr_name" required has-feedback
                                                :validate-status="checkdatastate.fr_name" :label-col="{ span: 10 }"
                                                :wrapper-col="{ span: 14 }"
                                                @change="() => (checkdatastate.fr_name = formState.fr_name ? 'success' : 'error')">
                                                <a-input style="margin-left: 5px;" placeholder="请输入姓名"
                                                    v-model:value="formState.fr_name"
                                                    :disabled="!(formState.status == 1 || formState.status == 3 || formState.status == null || state.user_permission == 'admin')" />
                                            </a-form-item>
                                        </a-col>
                                        <a-col :span="12">
                                            <a-form-item label="（法人代表/负责人）电话" name="fr_phone" required has-feedback
                                                :validate-status="checkdatastate.fr_phone" :label-col="{ span: 10 }"
                                                :wrapper-col="{ span: 14 }" style="margin-bottom: 0">
                                                <a-input placeholder="请输入电话" v-model:value="formState.fr_phone"
                                                    :disabled="!(formState.status == 1 || formState.status == 3 || formState.status == null || state.user_permission == 'admin')"
                                                    @change="(v) => phoneChange(v, 'fr_phone')" />
                                            </a-form-item>
                                        </a-col>
                                    </a-row>

                                    <!-- admin 补充信息 -->
                                    <div v-show="state.user_permission == 'admin'" class="admin-extra">
                                        <div class="admin-extra-title">补充信息（管理员填写）</div>
                                        <a-row :gutter="12">
                                            <a-col :span="4">
                                                <a-form-item-rest>
                                                    <a-form-item class="m-0" :label-col="{ span: 10 }"
                                                        :wrapper-col="{ span: 14 }" label="性别">
                                                        <a-select allow-clear v-model:value="formState.fr_gender"
                                                            placeholder="性别">
                                                            <a-select-option :value="1">男</a-select-option>
                                                            <a-select-option :value="2">女</a-select-option>
                                                        </a-select>
                                                    </a-form-item>
                                                </a-form-item-rest>
                                            </a-col>
                                            <a-col :span="8">
                                                <a-form-item-rest>
                                                    <a-form-item class="m-0" :label-col="{ span: 5 }"
                                                        :wrapper-col="{ span: 19 }" label="身份证号">
                                                        <a-input placeholder="请输入身份证号"
                                                            v-model:value="formState.fr_id_card_number" />
                                                    </a-form-item>
                                                </a-form-item-rest>
                                            </a-col>
                                            <a-col :span="12">
                                                <a-form-item-rest>
                                                    <a-form-item class="m-0" :label-col="{ span: 4 }"
                                                        :wrapper-col="{ span: 20 }" label="住址">
                                                        <a-input placeholder="请输入住所"
                                                            v-model:value="formState.fr_address" />
                                                    </a-form-item>
                                                </a-form-item-rest>
                                            </a-col>
                                            <a-col :span="4">
                                                <a-form-item-rest>
                                                    <a-form-item class="m-0" :label-col="{ span: 10 }"
                                                        :wrapper-col="{ span: 14 }" label="民族">
                                                        <a-select allow-clear v-model:value="formState.fr_nationality"
                                                            placeholder="民族">
                                                            <a-select-option
                                                                v-for="(item, index) in state.nationalityList"
                                                                :value="item" :key="index">
                                                                {{ item }}
                                                            </a-select-option>
                                                        </a-select>
                                                    </a-form-item>
                                                </a-form-item-rest>
                                            </a-col>
                                            <a-col :span="10">
                                                <a-form-item-rest>
                                                    <a-form-item class="m-0" :label-col="{ span: 6 }"
                                                        :wrapper-col="{ span: 18 }" label="有效期开始">
                                                        <a-date-picker placeholder="请选择" :format="format"
                                                            v-model:value="formState.fr_id_card_validity_start"
                                                            style="width: 100%" />
                                                    </a-form-item>
                                                </a-form-item-rest>
                                            </a-col>
                                            <a-col :span="10">
                                                <a-form-item-rest>
                                                    <a-form-item class="m-0" :label-col="{ span: 6 }"
                                                        :wrapper-col="{ span: 18 }" label="有效期结束">
                                                        <a-space>
                                                            <a-date-picker placeholder="请选择" :format="format"
                                                                v-model:value="formState.fr_id_card_validity_end"
                                                                :disabled="formState.fr_identity_perpetual == 1" />
                                                            <a-checkbox :checked="formState.fr_identity_perpetual == 1"
                                                                @change="identityPerpetualChange">
                                                                长期
                                                            </a-checkbox>
                                                        </a-space>
                                                    </a-form-item>
                                                </a-form-item-rest>
                                            </a-col>
                                        </a-row>
                                    </div>
                                </div>

                                <!-- 代办折叠 -->
                                <div class="foldable-block">
                                    <div class="foldable-header" @click="state.showDaiban = !state.showDaiban">
                                        <div class="foldable-left">
                                            <DownOutlined :class="['fold-icon', { open: state.showDaiban }]" />
                                            <span class="foldable-title">委托代办</span>
                                            <span class="foldable-sub">（非必填，仅刻章人不方便亲自到场时填写）</span>
                                        </div>
                                        <a-tag :color="formState.is_db == 1 ? 'orange' : 'default'">
                                            {{ formState.is_db == 1 ? '已启用' : '不需要' }}
                                        </a-tag>
                                    </div>
                                    <div v-show="state.showDaiban" class="foldable-body">
                                        <a-form-item label="是否代办" v-show="false">
                                            <a-radio-group v-model:value="formState.is_db">
                                                <a-radio :value="1">是</a-radio>
                                                <a-radio :value="2">否</a-radio>
                                            </a-radio-group>
                                        </a-form-item>

                                        <div class="daiban-switch">
                                            <a-radio-group v-model:value="formState.is_db" button-style="solid">
                                                <a-radio-button :value="1">是，需要代办</a-radio-button>
                                                <a-radio-button :value="2">否，不需要</a-radio-button>
                                            </a-radio-group>
                                        </div>

                                        <div v-if="formState.is_db == 1" class="daiban-fields">
                                            <a-form-item label="代办人身份证" :label-col="{ span: 4 }"
                                                :wrapper-col="{ span: 20 }">
                                                <div class="photo-row">
                                                    <div class="photo-item">
                                                        <a-spin :spinning="state.loading_db_front"
                                                            v-if="formState.status == 1 || formState.status == 3 || formState.status == null">
                                                            <a-form-item-rest>
                                                                <a-upload list-type="picture-card"
                                                                    accept=".jpeg,.png,.jpg" class="photo-uploader"
                                                                    :show-upload-list="false"
                                                                    :before-upload="beforeUpload"
                                                                    @change="(info) => handleChange(info, 'db_id_card_front')">
                                                                    <img v-if="formState.db_id_card_front"
                                                                        :src="$store.state.user.image_domain + formState.db_id_card_front"
                                                                        class="photo-img" />
                                                                    <div v-else class="photo-placeholder">
                                                                        <PlusOutlined />
                                                                        <div>人像面</div>
                                                                    </div>
                                                                </a-upload>
                                                            </a-form-item-rest>
                                                        </a-spin>
                                                    </div>
                                                    <div class="photo-item">
                                                        <a-spin :spinning="state.loading_db_back"
                                                            v-if="formState.status == 1 || formState.status == 3 || formState.status == null">
                                                            <a-form-item-rest>
                                                                <a-upload list-type="picture-card"
                                                                    accept=".jpeg,.png,.jpg" class="photo-uploader"
                                                                    :show-upload-list="false"
                                                                    :before-upload="beforeUpload"
                                                                    @change="(info) => handleChange(info, 'db_id_card_back')">
                                                                    <img v-if="formState.db_id_card_back"
                                                                        :src="$store.state.user.image_domain + formState.db_id_card_back"
                                                                        class="photo-img" />
                                                                    <div v-else class="photo-placeholder">
                                                                        <PlusOutlined />
                                                                        <div>国徽面</div>
                                                                    </div>
                                                                </a-upload>
                                                            </a-form-item-rest>
                                                        </a-spin>
                                                    </div>
                                                    <div class="photo-item">
                                                        <a-form-item-rest
                                                            v-if="formState.status == 1 || formState.status == 3 || formState.status == null">
                                                            <a-upload list-type="picture-card" accept=".jpeg,.png,.jpg"
                                                                class="photo-uploader" :show-upload-list="false"
                                                                :before-upload="beforeUpload"
                                                                @change="(info) => handleImageChange(info, 'db_one_inch_picture')">
                                                                <img v-if="formState.db_one_inch_picture"
                                                                    :src="$store.state.user.image_domain + formState.db_one_inch_picture"
                                                                    class="photo-img" />
                                                                <div v-else class="photo-placeholder">
                                                                    <PlusOutlined />
                                                                    <div>生活照</div>
                                                                </div>
                                                            </a-upload>
                                                        </a-form-item-rest>
                                                    </div>
                                                </div>
                                            </a-form-item>

                                            <a-row :gutter="16">
                                                <a-col :span="8">
                                                    <a-form-item label="代办人姓名" :label-col="{ span: 8 }"
                                                        :wrapper-col="{ span: 16 }">
                                                        <a-input placeholder="请输入姓名"
                                                            v-model:value="formState.db_name" />
                                                    </a-form-item>
                                                </a-col>
                                                <a-col :span="8">
                                                    <a-form-item label="代办人电话" :label-col="{ span: 8 }"
                                                        :wrapper-col="{ span: 16 }">
                                                        <a-input placeholder="请输入电话" v-model:value="formState.db_phone"
                                                            @change="(v) => phoneChange(v, 'db_phone')" />
                                                    </a-form-item>
                                                </a-col>
                                                <a-col :span="8">
                                                    <a-form-item label="授权委托书" :label-col="{ span: 8 }"
                                                        :wrapper-col="{ span: 16 }" style="margin-bottom: 0">
                                                        <Upload
                                                            :upload_path="`public/uploads/刻章管理/长沙哇哇叫刻章服务有限公司/客户资料/${dayjs().format('YYYYMM')}/${formState.full_name}/`"
                                                            :accept="['png', 'jpg', 'jpeg', 'pdf']"
                                                            uploadType="picture-card" :limitation="1"
                                                            v-model:value="formState.db_weituoshu"
                                                            :beforeCheck="beforeCheck" uploadText="上传" />
                                                    </a-form-item>
                                                </a-col>
                                            </a-row>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- ===== Step 2：取章方式 ===== -->
                            <div v-show="state.currentStep === 1" class="step-panel">
                                <div class="panel-card">
                                    <div class="mail-type-grid">
                                        <div class="mail-type-item" :class="{ active: formState.mailing_type === 3 }"
                                            @click="formState.mailing_type = 3; changeMailingType()">
                                            <ShopOutlined class="mail-icon" />
                                            <div class="mail-title">来店取货</div>
                                            <div class="mail-desc">到店自提，最快</div>
                                        </div>
                                        <div class="mail-type-item" :class="{ active: formState.mailing_type === 1 }"
                                            @click="formState.mailing_type = 1; changeMailingType()">
                                            <CarOutlined class="mail-icon" />
                                            <div class="mail-title">快递发货</div>
                                            <div class="mail-desc">顺丰发货，隔天送达</div>
                                        </div>
                                        <div class="mail-type-item" :class="{ active: formState.mailing_type === 2 }"
                                            @click="formState.mailing_type = 2; changeMailingType()">
                                            <RocketOutlined class="mail-icon" />
                                            <div class="mail-title">跑腿发货</div>
                                            <div class="mail-desc">同城配送，快速到达</div>
                                        </div>
                                        <div class="mail-type-item" :class="{ active: formState.mailing_type === 4 }"
                                            @click="formState.mailing_type = 4; changeMailingType()">
                                            <LinkOutlined class="mail-icon" />
                                            <div class="mail-title">合并邮寄</div>
                                            <div class="mail-desc">与其他订单一起寄</div>
                                        </div>
                                    </div>
                                </div>

                                <!-- 快递选项 -->
                                <div v-if="formState.mailing_type === 1" class="panel-card">
                                    <a-row :gutter="16">
                                        <a-col :span="12">
                                            <a-form-item label="快递公司" required :label-col="{ span: 6 }"
                                                :wrapper-col="{ span: 18 }" style="margin-bottom: 0">
                                                <a-radio-group v-model:value="formState.mailing_kdgs"
                                                    button-style="solid" @change="calcPrice">
                                                    <a-radio-button :value="2">顺丰快递</a-radio-button>
                                                </a-radio-group>
                                            </a-form-item>
                                        </a-col>
                                        <a-col :span="12">
                                            <a-form-item label="付款方式" required :label-col="{ span: 6 }"
                                                :wrapper-col="{ span: 18 }" style="margin-bottom: 0">
                                                <a-radio-group v-model:value="formState.mailing_payment"
                                                    button-style="solid" @change="calcPrice">
                                                    <a-radio-button :value="1">寄付</a-radio-button>
                                                    <a-radio-button :value="2">到付</a-radio-button>
                                                </a-radio-group>
                                                <a-tooltip placement="top" color="white">
                                                    <template #title>
                                                        <div class="tooltip-table-container">
                                                            <table class="tooltip-table">
                                                                <thead>
                                                                    <tr>
                                                                        <th v-for="column in columns" :key="column.key">
                                                                            {{ column.title }}</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="item in data" :key="item.id">
                                                                        <td v-for="column in columns" :key="column.key">
                                                                            {{ item[column.dataIndex] }}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </template>
                                                    <a class="tip-link-btn">快递费说明</a>
                                                </a-tooltip>
                                            </a-form-item>
                                        </a-col>
                                    </a-row>
                                </div>

                                <!-- 跑腿选项 -->
                                <div v-if="formState.mailing_type === 2" class="panel-card">
                                    <a-form-item label="发货类型" required :label-col="{ span: 3 }"
                                        :wrapper-col="{ span: 21 }" style="margin-bottom: 0">
                                        <a-radio-group v-model:value="formState.mailing_paotui" button-style="solid">
                                            <a-radio-button :value="2">自行发货（快）</a-radio-button>
                                        </a-radio-group>
                                    </a-form-item>
                                    <div v-if="formState.mailing_paotui == 2" class="dashed-tip">
                                        <div class="tip-row"><span class="tip-label">寄件人姓名</span>填自己的姓名 或 填 刻章店</div>
                                        <div class="tip-row"><span class="tip-label">寄件人电话</span>填自己的电话 或 填 191 9821
                                            2078</div>
                                        <div class="tip-row"><span
                                                class="tip-label">刻章门店</span>长沙市芙蓉区马王堆街道浏阳河新桥家园8栋105号哇哇叫刻章店</div>
                                        <div class="tip-row">
                                            <span class="tip-label">寄件备注</span>务必写章的
                                            <span class="text-red">取件码</span>，下单后列表页自动出现
                                        </div>
                                    </div>
                                </div>

                                <!-- 来店取货 -->
                                <div v-if="formState.mailing_type === 3" class="panel-card">
                                    <div class="store-info">
                                        <EnvironmentOutlined class="store-icon" />
                                        <div>
                                            <div class="store-title">哇哇叫刻章店</div>
                                            <div class="store-addr">湖南省长沙市芙蓉区马王堆街道浏阳河新桥家园8栋105号</div>
                                            <div class="store-time">工作时间：早 9:00 - 晚 18:00</div>
                                            <div class="store-tip">到周围后如果找不到地址，请联系 18898771212</div>
                                        </div>
                                    </div>
                                </div>

                                <!-- 收货人信息（快递发货时全部必填） -->
                                <div v-if="formState.mailing_type === 1" class="panel-card">
                                    <div class="panel-sub-title">收货人信息</div>
                                    <a-row :gutter="[16, 16]">
                                        <a-col :span="12">
                                            <a-form-item label="收货人" required :label-col="{ span: 6 }"
                                                :wrapper-col="{ span: 18 }"
                                                :validate-status="checkdatastate.recipient_name" has-feedback
                                                style="margin-bottom: 0"
                                                @change="() => (checkdatastate.recipient_name = formState.recipient_name ? 'success' : 'error')">
                                                <a-input placeholder="请输入收货人姓名"
                                                    v-model:value="formState.recipient_name" />
                                            </a-form-item>
                                        </a-col>
                                        <a-col :span="12">
                                            <a-form-item label="手机号码" required :label-col="{ span: 6 }"
                                                :wrapper-col="{ span: 18 }"
                                                :validate-status="checkdatastate.recipient_mobile" has-feedback
                                                style="margin-bottom: 0">
                                                <a-input-group compact>
                                                    <a-input style="width: calc(100% - 110px)"
                                                        :value="formState.recipient_mobile" placeholder="请输入手机号"
                                                        @change="(v) => phoneChange(v, 'recipient_mobile')" />
                                                    <a-button type="primary" :loading="state.emailLoading"
                                                        @click="emailChange">
                                                        自动获取
                                                    </a-button>
                                                </a-input-group>
                                            </a-form-item>
                                        </a-col>
                                        <a-col :span="24">
                                            <a-form-item label="省市区" required :label-col="{ span: 3 }"
                                                :wrapper-col="{ span: 21 }"
                                                :validate-status="checkdatastate.recipient_area_ids" has-feedback
                                                style="margin-bottom: 0">
                                                <AddressCascader v-model:value="formState.recipient_area_ids"
                                                    @change="residenceChange" />
                                            </a-form-item>
                                        </a-col>
                                        <a-col :span="24">
                                            <a-form-item label="详细地址" required :label-col="{ span: 3 }"
                                                :wrapper-col="{ span: 21 }"
                                                :validate-status="checkdatastate.recipient_address" has-feedback
                                                style="margin-bottom: 0"
                                                @change="() => (checkdatastate.recipient_address = formState.recipient_address ? 'success' : 'error')">
                                                <a-textarea placeholder="请输入详细地址"
                                                    v-model:value="formState.recipient_address" :rows="2" />
                                                <a-button type="link" size="small" @click="parseReceiveAddress"
                                                    :loading="state.parseReceiveAddressLoading" style="padding-left: 0">
                                                    <ScanOutlined /> 智能识别地址
                                                </a-button>
                                            </a-form-item>
                                        </a-col>
                                        <a-col :span="12">
                                            <a-form-item label="邮编" required :label-col="{ span: 6 }"
                                                :wrapper-col="{ span: 18 }" style="margin-bottom: 0">
                                                <a-input placeholder="请输入邮编" v-model:value="formState.zipcode" />
                                            </a-form-item>
                                        </a-col>
                                    </a-row>
                                </div>

                                <!-- 跑腿自行发货时收货人信息也必填 -->
                                <div v-if="formState.mailing_type === 2 && formState.mailing_paotui === 1"
                                    class="panel-card">
                                    <div class="panel-sub-title">收货人信息</div>
                                    <a-row :gutter="[16, 16]">
                                        <a-col :span="12">
                                            <a-form-item label="收货人" required :label-col="{ span: 6 }"
                                                :wrapper-col="{ span: 18 }"
                                                :validate-status="checkdatastate.recipient_name" has-feedback
                                                style="margin-bottom: 0"
                                                @change="() => (checkdatastate.recipient_name = formState.recipient_name ? 'success' : 'error')">
                                                <a-input placeholder="请输入收货人姓名"
                                                    v-model:value="formState.recipient_name" />
                                            </a-form-item>
                                        </a-col>
                                        <a-col :span="12">
                                            <a-form-item label="手机号码" required :label-col="{ span: 6 }"
                                                :wrapper-col="{ span: 18 }"
                                                :validate-status="checkdatastate.recipient_mobile" has-feedback
                                                style="margin-bottom: 0">
                                                <a-input-group compact>
                                                    <a-input style="width: calc(100% - 110px)"
                                                        :value="formState.recipient_mobile" placeholder="请输入手机号"
                                                        @change="(v) => phoneChange(v, 'recipient_mobile')" />
                                                    <a-button type="primary" :loading="state.emailLoading"
                                                        @click="emailChange">
                                                        自动获取
                                                    </a-button>
                                                </a-input-group>
                                            </a-form-item>
                                        </a-col>
                                        <a-col :span="24">
                                            <a-form-item label="省市区" required :label-col="{ span: 3 }"
                                                :wrapper-col="{ span: 21 }"
                                                :validate-status="checkdatastate.recipient_area_ids" has-feedback
                                                style="margin-bottom: 0">
                                                <AddressCascader v-model:value="formState.recipient_area_ids"
                                                    @change="residenceChange" />
                                            </a-form-item>
                                        </a-col>
                                        <a-col :span="24">
                                            <a-form-item label="详细地址" required :label-col="{ span: 3 }"
                                                :wrapper-col="{ span: 21 }"
                                                :validate-status="checkdatastate.recipient_address" has-feedback
                                                style="margin-bottom: 0"
                                                @change="() => (checkdatastate.recipient_address = formState.recipient_address ? 'success' : 'error')">
                                                <a-textarea placeholder="请输入详细地址"
                                                    v-model:value="formState.recipient_address" :rows="2" />
                                                <a-button type="link" size="small" @click="parseReceiveAddress"
                                                    :loading="state.parseReceiveAddressLoading" style="padding-left: 0">
                                                    <ScanOutlined /> 智能识别地址
                                                </a-button>
                                            </a-form-item>
                                        </a-col>
                                        <a-col :span="12">
                                            <a-form-item label="邮编" required :label-col="{ span: 6 }"
                                                :wrapper-col="{ span: 18 }" style="margin-bottom: 0">
                                                <a-input placeholder="请输入邮编" v-model:value="formState.zipcode" />
                                            </a-form-item>
                                        </a-col>
                                    </a-row>
                                </div>

                                <!-- 合并邮寄：选择订单必填 -->
                                <div v-if="formState.mailing_type === 4" class="panel-card">
                                    <a-form-item label="选择订单" required :label-col="{ span: 3 }"
                                        :wrapper-col="{ span: 21 }" style="margin-bottom: 0">
                                        <a-select allow-clear v-model:value="formState.mailing_pid"
                                            placeholder="请选择要合并的订单">
                                            <a-select-option v-for="(item, index) in state.mailingparents" :key="index"
                                                :value="item.id">
                                                取件码【{{ item.shibie_code }}】 · {{ item.full_name }}
                                            </a-select-option>
                                        </a-select>
                                    </a-form-item>
                                </div>
                            </div>

                            <!-- ===== Step 3：确认订单 ===== -->
                            <div v-show="state.currentStep === 2" class="step-panel">
                                <div class="panel-card">
                                    <div class="panel-sub-title">印章清单</div>
                                    <div class="seal-list">
                                        <div class="seal-list-item" v-if="formState.beian_zhang.includes('11')">
                                            <div class="seal-name">公章</div>
                                            <div class="seal-material">{{ formState.material_11_data?.name }}</div>
                                            <div class="seal-price">¥{{ formState.material_11_data?.price }}</div>
                                            <a-button size="small" v-if="state.materialList[11]?.length > 1"
                                                @click="chooseMaterial(11)">选材质</a-button>
                                        </div>
                                        <div class="seal-list-item" v-if="formState.beian_zhang.includes('12')">
                                            <div class="seal-name">财务章</div>
                                            <div class="seal-material">{{ formState.material_12_data?.name }}</div>
                                            <div class="seal-price">¥{{ formState.material_12_data?.price }}</div>
                                            <a-button size="small" v-if="state.materialList[12]?.length > 1"
                                                @click="chooseMaterial(12)">选材质</a-button>
                                        </div>
                                        <div class="seal-list-item" v-if="formState.beian_zhang.includes('13')">
                                            <div class="seal-name">法人代表章</div>
                                            <div class="seal-material">{{ formState.material_13_data?.name }}</div>
                                            <div class="seal-price">¥{{ formState.material_13_data?.price }}</div>
                                            <a-button size="small" v-if="state.materialList[13]?.length > 1"
                                                @click="chooseMaterial(13)">选材质</a-button>
                                        </div>
                                        <div class="seal-list-item" v-if="formState.beian_zhang.includes('14')">
                                            <div class="seal-name">合同章</div>
                                            <div class="seal-material">{{ formState.material_14_data?.name }}</div>
                                            <div class="seal-price">¥{{ formState.material_14_data?.price }}</div>
                                            <a-button size="small" v-if="state.materialList[14]?.length > 1"
                                                @click="chooseMaterial(14)">选材质</a-button>
                                        </div>
                                        <div class="seal-list-item" v-if="formState.beian_zhang.includes('15')">
                                            <div class="seal-name">发票章</div>
                                            <div class="seal-material">{{ formState.material_15_data?.name }}</div>
                                            <div class="seal-price">¥{{ formState.material_15_data?.price }}</div>
                                            <a-button size="small" v-if="state.materialList[15]?.length > 1"
                                                @click="chooseMaterial(15)">选材质</a-button>
                                        </div>
                                        <div class="seal-list-item" v-if="formState.beian_zhang.includes('16')">
                                            <div class="seal-name">其他章</div>
                                            <div class="seal-material">{{ formState.material_16_data?.name }}</div>
                                            <div class="seal-price">¥{{ formState.material_16_data?.price }}</div>
                                            <a-button size="small" v-if="state.materialList[16]?.length > 1"
                                                @click="chooseMaterial(16)">选材质</a-button>
                                        </div>
                                    </div>
                                </div>

                                <div class="panel-card">
                                    <div class="panel-sub-title">其他费用明细</div>
                                    <div class="fee-row">
                                        <div class="fee-label">
                                            <a-checkbox v-model:checked="anxinCheckbox" @change="anxinUseChange">
                                                安心 USE 加油服务
                                            </a-checkbox>
                                            <div class="fee-sub">不限次到店免费加油，赠送 1 瓶 10ML 印油</div>
                                        </div>
                                        <div class="fee-value"></div>
                                    </div>
                                    <div class="fee-row">
                                        <div class="fee-label">邮费</div>
                                        <div class="fee-value text-price">¥{{ formState.postage }}</div>
                                    </div>
                                    <div class="fee-row" v-if="state.dhmCoupon">
                                        <div class="fee-label">兑换码优惠</div>
                                        <div class="fee-value text-red">-¥{{ state.dhmCoupon.coupon_amout }}</div>
                                    </div>
                                    <div class="fee-row" v-if="props.custDhm">
                                        <div class="fee-label">兑换码</div>
                                        <div class="fee-value">{{ props.custDhm }}</div>
                                    </div>
                                </div>

                                <div class="panel-card">
                                    <div class="panel-sub-title">订单备注</div>
                                    <a-row :gutter="[16, 14]">
                                        <a-col :span="12">
                                            <a-form-item label="来源号码" :label-col="{ span: 6 }"
                                                :wrapper-col="{ span: 18 }" style="margin-bottom: 0">
                                                <a-input placeholder="请输入来源手机号" v-model:value="formState.from_tel"
                                                    @change="(v) => phoneChange(v, 'from_tel')" />
                                            </a-form-item>
                                        </a-col>
                                        <a-col :span="24">
                                            <a-form-item label="订单备注" :label-col="{ span: 3 }"
                                                :wrapper-col="{ span: 21 }" style="margin-bottom: 0">
                                                <a-textarea placeholder="方便自己记忆，非必填"
                                                    v-model:value="formState.order_note" :rows="2" />
                                            </a-form-item>
                                        </a-col>
                                    </a-row>
                                </div>

                                <div class="help-collapse">
                                    <a-collapse ghost>
                                        <a-collapse-panel key="1" header="我们与别人不同的地方">
                                            <p>✅ <b>真检测</b>：每枚印章人工检测合格才寄出，配合格证明</p>
                                            <p>✅ <b>真备案</b>：高清拍照后报公安局备案，提供备案证明/回执</p>
                                            <p>✅ <b>真售后</b>：质量问题免费维修</p>
                                        </a-collapse-panel>
                                        <a-collapse-panel key="2" header="资料下载">
                                            <p>
                                                <a @click="getFileDownLoad('分公司刻章，总公司授权书2026.docx')">
                                                    📄 分公司刻章，总公司授权书.docx
                                                </a>
                                            </p>
                                            <p>
                                                <a @click="getFileDownLoad('主体名称变更或印章损坏更换注销印章证明2026.docx')">
                                                    📄 主体名称变更或印章损坏更换注销证明.docx
                                                </a>
                                            </p>
                                        </a-collapse-panel>
                                    </a-collapse>
                                </div>
                            </div>
                        </main>
                    </a-form>
                </a-spin>
            </div>

            <!-- ==================== 底部 ==================== -->
            <div class="shell-footer">
                <div class="footer-left">
                    <div class="footer-amount">
                        <span class="amount-label">合计金额</span>
                        <span class="amount-value">
                            ¥{{
                                state.dhmCoupon
                                    ? Math.max(0, formState.actually_paid_money - state.dhmCoupon.coupon_amout)
                                    : formState.actually_paid_money
                            }}
                        </span>
                        <span v-if="formState.postage > 0" class="amount-sub">
                            （含邮费 ¥{{ formState.postage }}）
                        </span>
                    </div>
                </div>
                <div class="footer-right">
                    <a-button v-if="state.currentStep > 0" @click="handlePrevStep" size="large">
                        <LeftOutlined /> 上一步
                    </a-button>
                    <a-button v-if="state.currentStep < 2" type="primary" size="large" @click="handleNextStep">
                        下一步
                        <RightOutlined />
                    </a-button>
                    <a-button v-else type="primary" size="large" @click="onFormSubmit" :loading="state.loading">
                        <CheckOutlined /> 提交订单
                    </a-button>
                </div>
            </div>
        </div>

        <!-- ==================== 裁剪 / 材质弹窗 ==================== -->
        <image-cropper v-if="state.showCropper" @cancel="() => (state.showCropper = false)"
            :isId="state.currentUpload == 'id_card_front' || state.currentUpload == 'id_card_back'"
            :imageUrl="state.imageUrl" :imageName="state.imageName"
            :upload_path="`public/uploads/刻章管理/长沙哇哇叫刻章服务有限公司/客户资料/${dayjs().format('YYYYMM')}/${formState.full_name}/`"
            :customerName="formState.full_name" :minKbSize="50" :isTiqianClose="true" @change="cropperPost" />
        <image-cropper v-if="state.showImageCropper" @cancel="() => (state.showImageCropper = false)"
            :windowsSize="[130, 180]" :isId="false" :imageUrl="state.imageUrl" :imageName="state.imageName"
            @change="cropperImageChange"
            :upload_path="`public/uploads/刻章管理/长沙哇哇叫刻章服务有限公司/客户资料/${dayjs().format('YYYYMM')}/${formState.full_name}/`"
            :customerName="formState.full_name" :minKbSize="50" />
        <image-cropper v-if="state.showLicenceCropper" @cancel="() => (state.showLicenceCropper = false)"
            :windowsSize="[426, 305]" :isId="false" :imageUrl="state.imageUrl" :imageName="state.imageName"
            @change="cropperLicenceChange"
            :upload_path="`public/uploads/kezhang_fileupload_tmp/${dayjs().format('YYYYMM')}/`"
            :customerName="formState.full_name" :minKbSize="50" />
        <Material v-if="materialData.visible" :zhangType="materialData.zhangType" :optionList="materialData.optionList"
            :defaultValue="materialData.defaultValue" @cancel="materialData.visible = false" @ok="materialOk" />
    </a-modal>
</template>

<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, h, computed } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import ImageCropper from '@/components/ImageCropper/index.vue'
import dayjs from 'dayjs'
import cloneDeep from 'lodash.clonedeep'
import { useStore } from 'vuex'
import sfIconBlack from '@/assets/icons/sf-icon-black.png'
import sfIconWhite from '@/assets/icons/sf-icon-white.png'
import {
    ScanOutlined,
    CloudDownloadOutlined,
    LeftOutlined,
    RightOutlined,
    CheckOutlined,
    MinusOutlined,
    PlusOutlined,
    VerticalAlignBottomOutlined,
    DownOutlined,
    ShopOutlined,
    CarOutlined,
    RocketOutlined,
    LinkOutlined,
    EnvironmentOutlined
} from '@ant-design/icons-vue'
import Upload from '@/components/base/Upload.vue'
import AddressCascader from '@/components/base/AddressCascader.vue'
import Material from './Material.vue'
import { parseAddress } from '@/utils/util'

const $store = useStore()
let dayTime = dayjs()
import ls from '@/utils/Storage'
const user = ls.get('USER_INFO')
const emit = defineEmits(['cancel', 'ok'])
const ruleForm = ref()
const props = defineProps({
    open: { type: Boolean },
    tableColumnsData: { type: Object, default: () => null },
    customerData: { type: Object, default: () => null },
    custDhm: { type: String, default: '' }
})

const formLayout = {
    labelCol: { xs: { span: 4 }, sm: { span: 4 } },
    wrapperCol: { xs: { span: 15 }, sm: { span: 15 } }
}
const columns = ref([
    { key: 'name', title: '快递公司', dataIndex: 'name' },
    { key: 'shinei', title: '市内', dataIndex: 'shinei' },
    { key: 'shengnei', title: '省内', dataIndex: 'shengnei' },
    { key: 'shengwai', title: '省外', dataIndex: 'shengwai' },
    { key: 'beizhu', title: '备注', dataIndex: 'beizhu' }
])
const data = ref([
    {
        id: 1,
        name: '顺丰快递',
        shinei: '寄付0元/到付12元',
        shengnei: '寄付0元/到付13元',
        shengwai: '寄付9元起/到付18元起',
        beizhu: '当天发货，隔天送达'
    }
])

interface state {
    modalTitle: string
    loading: boolean
    loading_front: boolean
    loading_back: boolean
    loading_db_front: boolean
    loading_db_back: boolean
    showCropper: boolean
    showImageCropper: boolean
    showLicenceCropper: boolean
    imageUrl: string
    imageName: string
    currentUpload: string
    nationalityList: string[]
    emailLoading: boolean
    priceLoading: boolean
    identifyItLoading: boolean
    materialList: any
    mailingparents: any[]
    user_permission: string
    showAttach: boolean
    parseReceiveAddressLoading: boolean
    dhmCoupon: any
    currentStep: number
    showDaiban: boolean
}
const state = reactive<state>({
    modalTitle: '刻章下单',
    loading: false,
    loading_front: false,
    loading_back: false,
    loading_db_front: false,
    loading_db_back: false,
    showCropper: false,
    showImageCropper: false,
    showLicenceCropper: false,
    imageUrl: '',
    imageName: '',
    currentUpload: '',
    nationalityList: [
        '汉族', '蒙古族', '回族', '藏族', '维吾尔族', '苗族', '彝族', '壮族', '布依族', '朝鲜族',
        '满族', '侗族', '瑶族', '白族', '土家族', '哈尼族', '哈萨克族', '傣族', '黎族', '傈僳族',
        '佤族', '畲族', '高山族', '拉祜族', '水族', '东乡族', '纳西族', '景颇族', '柯尔克孜族',
        '土族', '达斡尔族', '仫佬族', '羌族', '布朗族', '撒拉族', '毛难族', '仡佬族', '锡伯族',
        '阿昌族', '普米族', '塔吉克族', '怒族', '乌孜别克族', '俄罗斯族', '鄂温克族', '崩龙族',
        '保安族', '裕固族', '京族', '塔塔尔族', '独龙族', '额伦春族', '赫哲族', '门巴族', '洛巴族',
        '基诺族', '其他', '外国血统中国籍人士'
    ],
    emailLoading: false,
    priceLoading: false,
    identifyItLoading: false,
    materialList: {},
    mailingparents: [],
    user_permission: 'seller',
    showAttach: false,
    parseReceiveAddressLoading: false,
    dhmCoupon: null,
    currentStep: 0,
    showDaiban: false
})

const anxinCheckbox = computed({
    get: () => formState.anxin_use === 1,
    set: (val) => {
        formState.anxin_use = val ? 1 : 2
    }
})

let validateEnd = (rule, value) => {
    if (!value && formState.fr_identity_perpetual != 1) {
        return Promise.reject(new Error('请选择身份证结束日期'))
    } else if (value && formState.fr_identity_perpetual != 1) {
        const start = dayjs(value, 'YYYY-MM-DD')
        const diff = start.diff(dayTime, 'day')
        if (diff < 5) {
            return Promise.reject(new Error('身份证结束日期不能少于5天'))
        }
        return Promise.resolve()
    }
    return Promise.resolve()
}
const rules = {
    fr_id_card_validity_start: [{ required: false, message: '请选择身份证开始日期', trigger: 'change', type: 'object' }],
    fr_id_card_validity_end: [{ required: false, validator: validateEnd, trigger: 'change' }],
    fr_phone: [
        { required: true, message: '请输入法人手机号', trigger: 'change' },
        { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的11位法人手机号' }
    ]
}

interface formState {
    full_name: string
    social_credit_code: string
    unit_type: number
    fr_name: string
    fr_phone: string
    fr_gender: string | null
    fr_id_card_number: string | null
    fr_address: string | null
    fr_nationality: string | null
    fr_identity_perpetual: number | null
    fr_id_card_validity_start: any
    fr_id_card_validity_end: any
    licence_url: string
    one_inch_picture: string
    id_card_front: string
    id_card_back: string
    is_db: number
    db_name: string
    db_phone: string
    db_one_inch_picture: string
    db_id_card_front: string
    db_id_card_back: string
    db_weituoshu: string
    beian_zhang: string[]
    material_11_data: any
    material_12_data: any
    material_13_data: any
    material_14_data: any
    material_15_data: any
    material_16_data: any
    actually_paid_money: number
    postage: number
    mailing_type: number
    mailing_kdgs: number
    mailing_payment: number
    mailing_paotui: number
    mailing_pid: number | null
    recipient_name: string
    recipient_mobile: string
    zipcode: string
    recipient_address: string
    recipient_area_ids: string | undefined
    order_note: string
    from_tel: string
    status: number | null
    pay_status: number | null
    anxin_use: number
    licence_address: string
    licence_province: string
    licence_city: string
    licence_district: string
    attach_url: string[]
    is_sunhuai: number
    source_customer_id: number | null
    custdhm: string
}
const formState = reactive<formState>({
    full_name: '',
    social_credit_code: '',
    unit_type: 1,
    fr_name: '',
    fr_phone: '',
    fr_gender: null,
    fr_id_card_number: null,
    fr_address: null,
    fr_nationality: null,
    fr_identity_perpetual: 2,
    fr_id_card_validity_start: null,
    fr_id_card_validity_end: null,
    licence_url: '',
    one_inch_picture: '',
    id_card_front: '',
    id_card_back: '',
    is_db: 2,
    db_name: '',
    db_phone: '',
    db_one_inch_picture: '',
    db_id_card_front: '',
    db_id_card_back: '',
    db_weituoshu: '',
    beian_zhang: [],
    material_11_data: null,
    material_12_data: null,
    material_13_data: null,
    material_14_data: null,
    material_15_data: null,
    material_16_data: null,
    actually_paid_money: 0,
    postage: 0,
    mailing_type: 1,
    mailing_kdgs: 2,
    mailing_payment: 1,
    mailing_paotui: 2,
    mailing_pid: null,
    recipient_name: '',
    recipient_mobile: '',
    zipcode: '410000',
    recipient_address: '',
    recipient_area_ids: undefined,
    order_note: '',
    from_tel: '',
    status: null,
    pay_status: null,
    anxin_use: 2,
    licence_address: '',
    licence_province: '',
    licence_city: '',
    licence_district: '',
    attach_url: [],
    is_sunhuai: 2,
    source_customer_id: null,
    custdhm: ''
})

// ==================== 步骤控制 ====================
const handlePrevStep = () => {
    if (state.currentStep > 0) state.currentStep--
}

const handleNextStep = async () => {
    if (state.currentStep === 0) {
        if (formState.beian_zhang.length < 1) return message.warning('请选择刻章类型')
        if (!formState.full_name) return message.warning('请输入主体名称')
        if (!formState.licence_url) return message.warning('请上传营业执照')
        if (!formState.id_card_front || !formState.id_card_back || !formState.one_inch_picture)
            return message.warning('请上传法人代表（负责人）身份证及自拍照')
        if (!formState.fr_name) return message.warning('请输入法人代表（负责人）姓名')
        if (!formState.fr_phone) return message.warning('请输入法人代表（负责人）电话')
        try {
            await ruleForm.value.validate()
        } catch (e) {
            return message.warning('请检查表单必填项')
        }
        state.currentStep = 1
        return
    }
    if (state.currentStep === 1) {
        if (!formState.mailing_type) return message.warning('请选择取章方式')
        if (formState.mailing_type === 1) {
            if (!formState.recipient_name) return message.warning('请输入收货人姓名')
            if (!formState.recipient_mobile) return message.warning('请输入收货人手机号')
            if (!formState.recipient_area_ids) return message.warning('请选择收货人省市区')
            if (!formState.recipient_address) return message.warning('请输入收货人详细地址')
            if (!formState.zipcode) return message.warning('请输入邮编')
        }
        if (formState.mailing_type === 2 && formState.mailing_paotui === 1) {
            if (!formState.recipient_name) return message.warning('请输入收货人姓名')
            if (!formState.recipient_mobile) return message.warning('请输入收货人手机号')
            if (!formState.recipient_area_ids) return message.warning('请选择收货人省市区')
            if (!formState.recipient_address) return message.warning('请输入收货人详细地址')
            if (!formState.zipcode) return message.warning('请输入邮编')
        }
        if (formState.mailing_type === 4 && !formState.mailing_pid) return message.warning('请选择合并邮寄的订单')
        state.currentStep = 2
        return
    }
}

const phoneChange = (v, type) => {
    let str = v.target.value.replaceAll(/\D/g, '')
    formState[type] = str
    if (!/^1[23456789]\d{9}$/.test(str)) {
        checkdatastate[type] = 'error'
    } else {
        checkdatastate[type] = 'success'
        formState[type] = str
    }
}

onMounted(() => {
    state.currentStep = 0
    state.showDaiban = false
    initMaterial()
    if (props.tableColumnsData?.id) {
        if (props.tableColumnsData.isCopy) {
            setTimeout(() => queryDetail(props.tableColumnsData.id), 100)
            state.modalTitle = '再下一单'
        } else {
            setTimeout(() => queryDetail(props.tableColumnsData.id), 100)
            state.modalTitle = '编辑刻章'
        }
    } else if (props.customerData) {
        initCreate(props.customerData.id ?? 0)
        if (props.custDhm) {
            formState.custdhm = props.custDhm
            getDhmInfo(formState.custdhm)
        }
    }
    if (!props.tableColumnsData?.id && user.id != 88) {
        formState.recipient_mobile = user.phone
        emailChange()
    }
    initMailingparents()
})

const initCreate = (customer_id) => {
    state.loading = true
    baseService({
        url: `/admin/v1/kezhang/create`,
        method: 'post',
        data: { customer_id: customer_id }
    }).then((res: any) => {
        state.loading = false
        formState.beian_zhang = ['11', '12', '13']
        formState.source_customer_id = customer_id
        if (res.data.fr_id_card_validity_end) res.data.fr_id_card_validity_end = dayjs(res.data.fr_id_card_validity_end, format)
        if (res.data.fr_id_card_validity_start) res.data.fr_id_card_validity_start = dayjs(res.data.fr_id_card_validity_start, format)
        Object.assign(formState, res.data)
        if (res.data.recipient_province_id && res.data.recipient_city_id && res.data.recipient_area_id) {
            formState.recipient_area_ids = res.data.recipient_province_id + ',' + res.data.recipient_city_id + ',' + res.data.recipient_area_id
        }
        calcPrice()
        fullnameChange()
    })
}

const queryDetail = (id) => {
    state.loading = true
    baseService({ url: `/admin/v1/kezhang/${id}/edit`, method: 'get' }).then((res) => {
        state.loading = false
        if (props.tableColumnsData?.id > 0 && props.tableColumnsData.isCopy) {
            res.data.actually_paid_money -= res.data.add_price
            res.data.add_price = 0
        }
        res.data.fr_id_card_validity_end = dayjs(res.data.fr_id_card_validity_end, format)
        res.data.fr_id_card_validity_start = dayjs(res.data.fr_id_card_validity_start, format)
        Object.assign(formState, res.data)
        if (res.data.recipient_province_id && res.data.recipient_city_id && res.data.recipient_area_id) {
            formState.recipient_area_ids = res.data.recipient_province_id + ',' + res.data.recipient_city_id + ',' + res.data.recipient_area_id
        }
        if (props.tableColumnsData?.id > 0 && props.tableColumnsData.isCopy) formState.status = null
        state.user_permission = res.data.user_permission
        fullnameChange()
    })
}
const beforeCheck = () => {
    if (formState.full_name == '') {
        message.warning('请先输入主体名称')
        return false
    }
    return true
}
const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
    if (!isJpgOrPng) message.error('请上传正确图片！')
    const isLt2M = file.size / 1024 / 1024 < 10
    if (!isLt2M) message.error('图片必须小于10MB!')
    return false
}
const handleChange = (info, type) => {
    state.currentUpload = type
    const reader: any = new FileReader()
    const isGt50K = info.file.size / 1024 < 50
    if (isGt50K) {
        message.error('图片必须大于50KB!')
        return
    }
    state.imageName = info.file.name
    reader.readAsDataURL(info.file)
    reader.onload = () => {
        state.imageUrl = reader.result
        state.showCropper = true
    }
}
const cropperPost = (formData, isRecognize) => {
    let currentUpload = state.currentUpload
    state.showCropper = false
    if (currentUpload == 'id_card_front') state.loading_front = true
    else if (currentUpload == 'id_card_back') state.loading_back = true
    else if (currentUpload == 'db_id_card_front') state.loading_db_front = true
    else if (currentUpload == 'db_id_card_back') state.loading_db_back = true

    const url = isRecognize ? '/admin/v1/ocr' : '/admin/v1/upload'
    baseService({ url, method: 'post', data: formData })
        .then((res) => {
            if (currentUpload == 'id_card_front') state.loading_front = false
            else if (currentUpload == 'id_card_back') state.loading_back = false
            else if (currentUpload == 'db_id_card_front') state.loading_db_front = false
            else if (currentUpload == 'db_id_card_back') state.loading_db_back = false
            cropperChange(isRecognize ? res : res.data, isRecognize, currentUpload)
        })
        .catch((res) => {
            if (res.msg) message.error(res.msg)
            else message.error('操作失败')
            if (currentUpload == 'id_card_front') state.loading_front = false
            else if (currentUpload == 'id_card_back') state.loading_back = false
            else if (currentUpload == 'db_id_card_front') state.loading_db_front = false
            else if (currentUpload == 'db_id_card_back') state.loading_db_back = false
        })
}
const format = 'YYYY-MM-DD'
const cropperChange = (res, isRecognize, currentUpload) => {
    if (isRecognize) {
        let data = res.data.身份证识别实体信息
        if (currentUpload == 'id_card_back') {
            if (data.身份证国徽面实体信息.有效期限.length < 1) {
                message.error('请上传身份证正面照片（国徽面）')
                formState.id_card_back = ''
                return
            }
            let list = data.身份证国徽面实体信息.有效期限.split('-').map((item) => item.replaceAll('.', '-'))
            Object.assign(formState, {
                fr_id_card_validity_start: dayjs(list[0], format),
                fr_id_card_validity_end: dayjs(list[1], format),
                fr_identity_perpetual: list[1] == '长期' ? 1 : 2
            })
        } else if (currentUpload == 'id_card_front') {
            if (data.身份证人像面实体信息.姓名.length < 1) {
                message.error('请上传身份证反面照片（人像面）')
                formState.id_card_front = ''
                return
            }
            let nationality: any = null
            state.nationalityList.forEach((item) => {
                if (item.indexOf(data.身份证人像面实体信息.民族) > -1) nationality = item
            })
            Object.assign(formState, {
                fr_name: data.身份证人像面实体信息.姓名,
                fr_address: data.身份证人像面实体信息.住址,
                fr_id_card_number: data.身份证人像面实体信息.身份证号,
                fr_gender: data.身份证人像面实体信息.性别 == '男' ? 1 : 2,
                fr_nationality: nationality
            })
        }
        formState[currentUpload] = res.data.url
    } else {
        formState[currentUpload] = res.url
    }
}
const handleImageChange = (info, type) => {
    state.currentUpload = type
    const reader: any = new FileReader()
    const isGt50K = info.file.size / 1024 < 50
    if (isGt50K) {
        message.error('图片必须大于50KB!')
        return
    }
    state.imageName = info.file.name
    reader.readAsDataURL(info.file)
    reader.onload = () => {
        state.imageUrl = reader.result
        state.showImageCropper = true
    }
}
const cropperImageChange = (res) => {
    formState[state.currentUpload] = res.url
    state.showImageCropper = false
}
const handleLicenceCropper = (info, type) => {
    state.currentUpload = type
    const reader: any = new FileReader()
    const isGt50K = info.file.size / 1024 < 50
    if (isGt50K) {
        message.error('图片必须大于50KB!')
        return
    }
    state.imageName = info.file.name
    reader.readAsDataURL(info.file)
    reader.onload = () => {
        state.imageUrl = reader.result
        state.showLicenceCropper = true
    }
}
const cropperLicenceChange = (res) => {
    formState[state.currentUpload] = res.url
    state.showLicenceCropper = false
    handleLicenceChange(null)
}
const changeMailingType = () => {
    if (user.id == 88) {
        formState.recipient_name = ''
        formState.recipient_mobile = ''
        formState.recipient_area_ids = ''
        formState.recipient_address = ''
        formState.zipcode = ''
    }
    if (formState.mailing_type == 1 && !formState.mailing_payment) formState.mailing_payment = 2
    if (formState.mailing_type == 2 && !formState.mailing_paotui) formState.mailing_paotui = 2
    calcPrice()
}
const handleLicenceChange = () => {
    if (!formState.licence_url) return
    state.identifyItLoading = true
    baseService({
        url: '/admin/v1/identifyIt',
        method: 'post',
        data: { imgurl: $store.state.user.image_domain + formState.licence_url }
    })
        .then((res) => {
            state.identifyItLoading = false
            let companyName = res.data['企业名称']
            formState.full_name = companyName.replace(/\(/g, '（').replace(/\)/g, '）')
            formState.social_credit_code = res.data['企业统一社会信用编码']
            formState.licence_address = res.data['企业注册地址']
            formState.licence_province = res.data['企业注册地址所在省份']
            formState.licence_city = res.data['企业注册地址所在城市']
            formState.licence_district = res.data['企业注册地址所在区域']
            fullnameChange()
            message.success('识别成功！')
        })
        .catch((res) => {
            state.identifyItLoading = false
            if (res.msg) message.error(res.msg)
            else message.error('识别失败')
        })
}
const changeBeianZhang = () => calcPrice()

const calcPrice = () => {
    state.priceLoading = true
    baseService({ url: '/admin/v1/kezhang/calcPrice', method: 'post', data: formState })
        .then((res: any) => {
            state.priceLoading = false
            formState.actually_paid_money = res.data.actually_paid_money
            formState.postage = res.data.postage
        })
        .catch((res) => {
            state.priceLoading = false
            if (res && res.msg) message.warning(res.msg)
        })
}
const residenceChange = (idList, value: any) => {
    let address = ''
    if (value) {
        address = `${value[0].name}${value[1].name}${value[2].name}`
        if (formState.recipient_address == address) checkdatastate.recipient_address = 'error'
    } else {
        checkdatastate.recipient_address = 'error'
    }
    formState.recipient_address = address
    calcPrice()
    checkdatastate.recipient_area_ids = formState.recipient_area_ids ? 'success' : 'error'
}
const emailChange = () => {
    if (!formState.recipient_mobile) {
        message.warn('请填写收货人手机号码再获取邮寄信息')
        return
    }
    state.emailLoading = true
    baseService({
        url: '/admin/v1/mailingAddressList',
        method: 'post',
        data: { page: 1, limit: 'all', customer_tel: formState.recipient_mobile }
    })
        .then((res: any) => {
            if (res.data.list?.length > 0) {
                formState.recipient_name = res.data.list[0].name
                formState.recipient_mobile = res.data.list[0].tel
                formState.recipient_area_ids = `${res.data.list[0].recipient_province_id},${res.data.list[0].recipient_city_id},${res.data.list[0].recipient_area_id}`
                formState.recipient_address = res.data.list[0].address
                checkdatastate.recipient_name = checkdatastate.recipient_mobile = checkdatastate.recipient_area_ids = checkdatastate.recipient_address = checkdatastate.zipcode = 'success'
            }
            calcPrice()
            state.emailLoading = false
        })
        .catch((res) => {
            if (res) {
                state.emailLoading = false
            }
        })
}
const identityPerpetualChange = (val) => {
    formState.fr_identity_perpetual = val.target.checked ? 1 : 2
    ruleForm.value.validateFields('fr_id_card_validity_end')
}
const anxinUseChange = () => {
    calcPrice()
}
const onFormSubmit = () => {
    if (
        !formState.id_card_front ||
        !formState.id_card_back ||
        !formState.one_inch_picture
    ) {
        message.warning('请上传身份证和头像')
        return
    }
    if (formState.is_db == 1) {
        if (!formState.db_id_card_front || !formState.db_id_card_back || !formState.db_one_inch_picture || !formState.db_weituoshu) {
            message.warning('请上传代办人身份证和头像，授权委托书')
            return
        }
    }
    if (formState.beian_zhang.length < 1) {
        message.warning('请选择刻章类型')
        return
    }
    if (!state.showAttach && formState.is_sunhuai != 1) formState.attach_url = []
    ruleForm.value
        .validate()
        .then(() => {
            state.loading = true
            const isEdit = props.tableColumnsData?.id > 0 && !props.tableColumnsData.isCopy
            baseService({
                url: isEdit ? '/admin/v1/kezhang/' + props.tableColumnsData.id : '/admin/v1/kezhang',
                method: isEdit ? 'put' : 'post',
                data: formState
            })
                .then((res: any) => {
                    state.loading = false
                    message.success(res.msg)
                    emit('ok', isEdit ? 'edit' : 'add', isEdit ? props.tableColumnsData.id : res.data)
                })
                .catch((res) => {
                    state.loading = false
                    message.warning(res.msg)
                })
        })
        .catch(() => {
            message.warning('请检查表单必填项')
        })
}

const initMaterial = () => {
    state.loading = true
    baseService({ url: '/admin/v1/kezhang/material', method: 'post', data: {} })
        .then((res: any) => {
            state.materialList = res.data
            formState.material_11_data = res.data[11][0]
            formState.material_12_data = res.data[12][0]
            formState.material_13_data = res.data[13][0]
            formState.material_14_data = res.data[14][0]
            formState.material_15_data = res.data[15][0]
            formState.material_16_data = res.data[16][0]
        })
        .catch((res) => {
            if (res.data) message.warning('查询材质失败')
            else message.warning(res.msg)
        })
        .finally(() => {
            state.loading = false
        })
}
const initMailingparents = () => {
    baseService({
        url: '/admin/v1/kezhang/mailingparents',
        method: 'post',
        data: { id: props.tableColumnsData && !props.tableColumnsData.isCopy ? props.tableColumnsData.id : 0 }
    })
        .then((res: any) => {
            state.mailingparents = res.data
        })
        .catch((res) => {
            if (res.data) message.warning('查询失败')
            else message.warning(res.msg)
        })
}
const materialData = reactive<any>({
    visible: false,
    zhangType: 11,
    defaultValue: null,
    optionList: []
})
const chooseMaterial = (type) => {
    materialData.zhangType = type
    const map = {
        11: formState.material_11_data,
        12: formState.material_12_data,
        13: formState.material_13_data,
        14: formState.material_14_data,
        15: formState.material_15_data,
        16: formState.material_16_data
    }
    materialData.defaultValue = map[type]
    materialData.optionList = state.materialList[type]
    materialData.visible = true
}
const materialOk = (type, val) => {
    const map = {
        11: 'material_11_data',
        12: 'material_12_data',
        13: 'material_13_data',
        14: 'material_14_data',
        15: 'material_15_data',
        16: 'material_16_data'
    }
    formState[map[type]] = val
    materialData.visible = false
    calcPrice()
}
const checkdatastate = reactive<any>({})
const fullnameChange = () => {
    state.showAttach = isFenCompany(formState.full_name)
    if (formState.full_name.includes('公司') || formState.full_name.includes('有限合伙') || formState.full_name.includes('个人独资')) {
        formState.unit_type = 1
    } else if (formState.full_name.includes('个体工商户')) {
        formState.unit_type = 2
    } else if (formState.full_name.includes('合作社')) {
        formState.unit_type = 3
    }
}
const isFenCompany = (full_name) => {
    let fenSuffix = ['分公司', '分厂', '分店', '营业部', '分部', '分中心']
    let isFen = false
    fenSuffix.forEach((item) => {
        if (full_name.includes(item)) isFen = true
    })
    if (!isFen) {
        if (/.*公司.*店/.test(full_name)) isFen = true
    }
    return isFen
}
const getFileDownLoad = (e) => {
    window.open('https://hncs.cskaiyela.com/storage/public/uploads/刻章管理/范本模板/' + e)
}
const parseReceiveAddress = () => {
    state.parseReceiveAddressLoading = true
    parseAddress(formState.recipient_address)
        .then((res: any) => {
            if (res.name) formState.recipient_name = res.name
            if (res.phone) formState.recipient_mobile = res.phone
            if (res.area_ids) formState.recipient_area_ids = res.area_ids
            if (res.address) formState.recipient_address = res.address
        })
        .catch((res) => {
            message.error(res)
        })
        .finally(() => {
            state.parseReceiveAddressLoading = false
        })
}
const getDhmInfo = (custDhm) => {
    baseService({
        url: '/admin/v1/kezhang/getDhmInfo',
        method: 'post',
        data: { custDhm, kezhangId: props.tableColumnsData?.id }
    })
        .then((res: any) => {
            state.dhmCoupon = res.data
        })
        .catch((res) => {
            message.error(res.msg || '兑换码查询失败')
        })
        .finally(() => {
            state.loading = false
        })
}
// 点击顶部步骤条切换
const handleStepClick = (step: number) => {
    if (step === state.currentStep) return
    state.currentStep = step
}
</script>

<style lang="less" scoped>
/* ==================== 弹窗外壳 ==================== */
.kezhang-shell {
    display: flex;
    flex-direction: column;
    background: #f5f7fa;
    height: 76vh;
    max-height: 800px;
    overflow: hidden;
}

/* ==================== 顶部步骤条 ==================== */
.shell-header {
    padding: 12px 32px 10px;
    background: #fff;
    border-bottom: 1px solid #f0f0f0;
    flex-shrink: 0;
}

.shell-steps {
    :deep(.ant-steps-item-title) {
        font-weight: 500;
        font-size: 13px;
    }

    :deep(.ant-steps-item-description) {
        font-size: 12px;
        color: #8c8c8c;
    }
}

/* ==================== 主体 ==================== */
.shell-body {
    flex: 1;
    overflow: hidden;
    position: relative;
    min-height: 0;
}

.shell-spin {
    height: 100%;

    :deep(.ant-spin-container) {
        height: 100%;
        display: flex;
    }
}

.shell-body :deep(.ant-spin-nested-loading),
.shell-body :deep(.ant-spin-container) {
    height: 100%;
}

.shell-body :deep(.ant-form) {
    height: 100%;
    display: flex;
    width: 100%;
}

/* ==================== 左侧导航 ==================== */
.shell-aside {
    width: 190px;
    flex-shrink: 0;
    background: #fff;
    border-right: 1px solid #f0f0f0;
    padding: 12px 10px;
    overflow-y: auto;

    .nav-item {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        padding: 10px 12px;
        border-radius: 8px;
        cursor: pointer;
        margin-bottom: 4px;
        transition: all 0.2s;

        &:hover {
            background: #f0f5ff;
        }

        &.active {
            background: #e6f4ff;

            .nav-index {
                background: #1677ff;
                color: #fff;
            }

            .nav-title {
                color: #1677ff;
            }
        }

        .nav-index {
            width: 22px;
            height: 22px;
            border-radius: 50%;
            background: #f0f0f0;
            color: #8c8c8c;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            font-weight: 600;
            flex-shrink: 0;
            transition: all 0.2s;
        }

        .nav-text {
            flex: 1;
            min-width: 0;

            .nav-title {
                font-size: 13px;
                font-weight: 500;
                color: #262626;
                line-height: 1.4;
            }

            .nav-desc {
                font-size: 11px;
                color: #8c8c8c;
                line-height: 1.5;
                margin-top: 2px;
            }
        }
    }
}

/* ==================== 右侧内容 ==================== */
.shell-main {
    flex: 1;
    overflow-y: auto;
    padding: 12px 20px;
    background: #f5f7fa;
    min-width: 0;
}

.step-panel {
    animation: fadeIn 0.25s ease;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(4px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.panel-card {
    background: #fff;
    border-radius: 10px;
    padding: 14px 22px;
    margin-bottom: 12px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);

    &:last-child {
        margin-bottom: 0;
    }

    :deep(.ant-form-item) {
        margin-bottom: 12px;
    }

    :deep(.ant-form-item:last-child) {
        margin-bottom: 0;
    }

    /* label 上下居中，折行也居中不歪 */
    :deep(.ant-form-item-label) {
        display: flex;
        align-items: center;
        min-height: 32px;
        padding-right: 12px;
    }

    :deep(.ant-form-item-label > label) {
        white-space: normal;
        word-break: break-word;
        line-height: 1.4;
        height: auto;
        display: inline-flex;
        align-items: center;
        justify-content: flex-end;
        width: 100%;
        text-align: right;
    }

    :deep(.ant-form-item-label > label::after) {
        content: '' !important;
        margin: 0 !important;
    }

    :deep(.ant-form-item-required::before) {
        display: inline-block;
        margin-right: 4px;
        color: #ff4d4f;
        font-size: 14px;
        font-family: SimSun, sans-serif;
        line-height: 1;
        content: '*';
        vertical-align: middle;
    }

    /* 【关键】给相邻 col 之间加间距，防止贴在一起 */
    :deep(.ant-form-item-control-input) {
        min-height: 32px;
    }
}

/* ==================== 主体信息里的左右字段间距 ==================== */
.licence-row {
    display: flex;
    gap: 16px;
    align-items: flex-start;
}

.licence-upload-wrap,
.licence-viewer {
    flex-shrink: 0;
}

.licence-uploader {
    :deep(.ant-upload.ant-upload-select-picture-card) {
        width: 160px !important;
        height: 110px !important;
        margin: 0;
        border-radius: 8px;
    }
}

.licence-img {
    width: 160px;
    height: 110px;
    object-fit: contain;
    border-radius: 8px;
}

.licence-placeholder {
    width: 160px;
    height: 110px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
    color: #8c8c8c;
    font-size: 12px;
}

.licence-fields {
    flex: 1;
    min-width: 0;
    padding-left: 8px;
}

/* ==================== 印章选择 ==================== */
.seal-group {
    width: 100%;
}

.seal-checkbox {
    font-size: 13px;
}

.seal-tags {
    .ant-tag {
        margin-bottom: 6px;
    }
}

/* ==================== 法人照片 ==================== */
.photo-row {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.photo-item {
    :deep(.ant-upload.ant-upload-select-picture-card) {
        width: 130px !important;
        height: 85px !important;
        margin: 0;
        border-radius: 8px;
    }
}

.photo-img {
    width: 130px;
    height: 85px;
    object-fit: cover;
    border-radius: 8px;
}

.photo-placeholder {
    width: 130px;
    height: 85px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
    color: #8c8c8c;
    font-size: 12px;
}

/* ==================== 提示文字 ==================== */
.inline-tip {
    display: block;
    margin-top: 4px;
    font-size: 12px;
    color: #8c8c8c;
    line-height: 1.5;

    a {
        color: #1677ff;
        margin-left: 4px;
    }
}

.tip-link-btn {
    display: inline-block;
    margin-left: 12px;
    color: #1677ff;
    font-size: 13px;
    cursor: pointer;
}

/* ==================== Admin 补充信息 ==================== */
.admin-extra {
    margin-top: 10px;
    padding: 10px 14px;
    background: #fafafa;
    border-radius: 8px;

    .admin-extra-title {
        font-size: 12px;
        font-weight: 500;
        color: #595959;
        margin-bottom: 8px;
    }
}

/* ==================== 折叠块 ==================== */
.foldable-block {
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
    margin-bottom: 10px;

    .foldable-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 18px;
        cursor: pointer;
        transition: background 0.2s;

        &:hover {
            background: #fafafa;
        }

        .foldable-left {
            display: flex;
            align-items: center;
            gap: 8px;

            .fold-icon {
                transition: transform 0.25s;
                color: #8c8c8c;
                font-size: 12px;

                &.open {
                    transform: rotate(180deg);
                }
            }

            .foldable-title {
                font-size: 13px;
                font-weight: 500;
                color: #262626;
            }

            .foldable-sub {
                font-size: 12px;
                color: #8c8c8c;
            }
        }
    }

    .foldable-body {
        padding: 0 18px 14px;
        border-top: 1px solid #f0f0f0;

        .daiban-switch {
            padding: 12px 0;
        }

        .daiban-fields {
            padding-top: 4px;
        }
    }
}

/* ==================== 取章方式卡片 ==================== */
.mail-type-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
}

.mail-type-item {
    padding: 14px 12px;
    border: 2px solid #f0f0f0;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.2s;
    text-align: center;

    &:hover {
        border-color: #91caff;
    }

    &.active {
        border-color: #1677ff;
        background: #f0f7ff;

        .mail-icon {
            color: #1677ff;
        }

        .mail-title {
            color: #1677ff;
        }
    }

    .mail-icon {
        font-size: 24px;
        color: #bfbfbf;
        margin-bottom: 6px;
        display: block;
        transition: color 0.2s;
    }

    .mail-title {
        font-size: 13px;
        font-weight: 500;
        color: #262626;
        margin-bottom: 2px;
        transition: color 0.2s;
    }

    .mail-desc {
        font-size: 12px;
        color: #8c8c8c;
    }
}

/* ==================== 门店信息 ==================== */
.store-info {
    display: flex;
    gap: 16px;
    padding: 4px 0;

    .store-icon {
        font-size: 32px;
        color: #1677ff;
        flex-shrink: 0;
    }

    .store-title {
        font-size: 15px;
        font-weight: 600;
        color: #262626;
        margin-bottom: 6px;
    }

    .store-addr {
        font-size: 13px;
        color: #595959;
        margin-bottom: 4px;
    }

    .store-time {
        font-size: 13px;
        color: #595959;
        margin-bottom: 4px;
    }

    .store-tip {
        font-size: 12px;
        color: #fa8c16;
        margin-top: 6px;
    }
}

/* ==================== 虚线提示 ==================== */
.dashed-tip {
    padding: 10px 14px;
    background: #fffbe6;
    border: 1px dashed #ffe58f;
    border-radius: 8px;
    margin-top: 10px;

    .tip-row {
        font-size: 13px;
        color: #595959;
        line-height: 1.7;

        .tip-label {
            display: inline-block;
            width: 90px;
            color: #8c8c8c;
        }

        .text-red {
            color: #f5222d;
            font-weight: 500;
        }
    }
}

/* ==================== Step 3 印章清单 ==================== */
.seal-list {
    .seal-list-item {
        display: flex;
        align-items: center;
        padding: 8px 0;
        border-bottom: 1px dashed #f0f0f0;

        &:last-child {
            border-bottom: none;
        }

        .seal-name {
            width: 100px;
            font-weight: 500;
            color: #262626;
        }

        .seal-material {
            flex: 1;
            color: #8c8c8c;
            font-size: 13px;
        }

        .seal-price {
            color: #fa8c16;
            font-weight: 600;
            font-size: 14px;
            margin-right: 16px;
            min-width: 80px;
            text-align: right;
        }
    }
}

/* ==================== 费用明细 ==================== */
.fee-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    border-bottom: 1px dashed #f0f0f0;

    &:last-child {
        border-bottom: none;
    }

    .fee-label {
        font-size: 13px;
        color: #262626;

        .fee-sub {
            font-size: 12px;
            color: #8c8c8c;
            margin-top: 2px;
        }
    }

    .fee-value {
        font-size: 14px;
        font-weight: 500;
        color: #262626;
    }

    .text-red {
        color: #f5222d;
    }

    .text-price {
        color: #fa8c16 !important;
        font-weight: 600 !important;
    }
}

/* ==================== 帮助折叠 ==================== */
.help-collapse {
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
    margin-bottom: 0;

    :deep(.ant-collapse-header) {
        font-weight: 500;
        padding: 10px 16px !important;
    }

    p {
        margin: 6px 0;
        color: #595959;
        font-size: 13px;
        line-height: 1.7;
    }
}

/* ==================== 底部 ==================== */
.shell-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 24px;
    background: #fff;
    border-top: 1px solid #f0f0f0;
    flex-shrink: 0;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.03);

    .footer-left {
        .footer-amount {
            display: flex;
            align-items: baseline;
            gap: 8px;

            .amount-label {
                font-size: 13px;
                color: #8c8c8c;
            }

            .amount-value {
                font-size: 22px;
                font-weight: 600;
                color: #fa541c;
                line-height: 1;
            }

            .amount-sub {
                font-size: 12px;
                color: #8c8c8c;
            }
        }
    }

    .footer-right {
        display: flex;
        gap: 12px;
    }
}

/* ==================== tooltip 表格 ==================== */
.tooltip-table-container {
    max-width: 400px;
    overflow: auto;
}

.tooltip-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
    background: white;
    color: #000;
}

.tooltip-table th {
    background-color: #fafafa;
    padding: 8px 12px;
    border: 1px solid #e8e8e8;
    text-align: left;
    font-weight: 600;
    white-space: nowrap;
}

.tooltip-table td {
    padding: 8px 12px;
    border: 1px solid #e8e8e8;
    white-space: nowrap;
}

.tooltip-table tr:nth-child(even) {
    background-color: #fafafa;
}
</style>

<style lang="less">
.kezhang-modal-wrap {
    .ant-modal-content {
        border-radius: 12px;
        overflow: hidden;
        padding: 0;
    }

    .ant-modal-header {
        padding: 14px 24px;
        margin-bottom: 0;
        border-bottom: 1px solid #f0f0f0;
        border-radius: 12px 12px 0 0;
    }

    .ant-modal-title {
        font-size: 15px;
        font-weight: 600;
    }

    .ant-modal-close {
        top: 14px;
    }
}

/* 顶部步骤条：可点击的交互提示 */
.clickable-steps {
    :deep(.clickable-step) {
        cursor: pointer;
        transition: opacity 0.2s;

        &:hover {
            opacity: 0.8;
        }
    }
}
</style>
